import React from "react";
import cta from "../../images/cta/Section image.png";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import androidImg from "../../images/Truslypay_imgs/android.png";
import iosImg from "../../images/Truslypay_imgs/apple.png";

const CtaSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={`cta ${props.cClass}`}>
      <div className="container">
        <div className="cta-wrap">
          <div className="cta-inner ul_li_between">
            <Fade
              direction="left"
              triggerOnce={"false"}
              duration={1000}
              delay={9}
            >
              <div>
                <div
                  className="xb-item--holder wow fadeInLeft"
                  data-wow-delay="100ms"
                  data-wow-duration="600ms"
                >
                  <h2 className="xb-item--title">Download the TigrisPay App</h2>
                  <span className="xb-item--content">
                    Send money across borders instantly, securely, and
                    affordably — right from your phone.
                  </span>

                  <div
                    className="mt-4 wow fadeInUp "
                    data-wow-delay="300ms"
                    data-wow-duration="600ms"
                  >
                    <a
                      href="https://play.google.com/store/apps/details?id=com.org.tigris"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                      className=" "
                    >
                      <img
                        className="download-app-playstore-apple mr-5 "
                        // style={{ height: "60px", width: "200px" }}
                        src={androidImg}
                        alt="Android App"
                      />
                    </a>

                    <a
                      href="https://apps.apple.com/us/app/tigrispay/id6754586181"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={ClickHandler}
                      className=" "
                    >
                      <img
                        className="download-app-playstore-apple ml-5 cta-custom"
                        // style={{ height: "63px", width: "200px" }}
                        src={iosImg}
                        alt="iOS App"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade
              direction="right"
              triggerOnce={"false"}
              duration={1000}
              delay={9}
            >
              <div>
                <div
                  className="cta-right_img wow fadeInRight"
                  data-wow-delay="150ms"
                  data-wow-duration="600ms"
                >
                  <img className="updown" src={cta} alt="" />
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
